import { render } from "./ProjectionsGraph.vue?vue&type=template&id=0523735c"
import script from "./ProjectionsGraph.vue?vue&type=script&lang=js"
export * from "./ProjectionsGraph.vue?vue&type=script&lang=js"

import "./ProjectionsGraph.vue?vue&type=style&index=0&id=0523735c&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__